<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="imprint__background module__background"
        >
        </app-modulebackground>
        <div
            class="imprint__container module__container"
            v-bind:class="{ container__boxed: [1, 2].includes(module.layout.type) }"
        >
            <div class="imprint__inner module__inner">
                <div class="imprint__inner--main module__inner--main">
                    <div class="imprint__inner-row module__inner-row">
                        <div class="imprint__inner-col module__inner-col">
                            <div
                                class="legal-text"
                                v-bind:data-company="
                                    encodeURIComponent(JSON.stringify(getLegalUserData))
                                "
                                v-bind:data-copyrights="encodeURIComponent('%REPLACE_COPYRIGHTS%')"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Imprint from '@/external/modules/Imprint';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getLegalUserData'])
    },
    mounted() {
        let i = new Imprint();
        i.init(this.$refs.root);
    },
    updated() {
        let i = new Imprint();
        i.init(this.$refs.root);
    },
    props: {
        module: Object
    }
};
</script>
